import type { OpportunityTask } from 'backend/types'
import { useCallback, useState } from 'react'

/**
 * タスクの編集・削除ダイアログの開閉状態を管理するフック
 */
export function useTasksDialogs() {
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [editingTask, setEditingTask] = useState<OpportunityTask | null>(null)

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
  const [deletingTask, setDeletingTask] = useState<OpportunityTask | null>(null)

  const handleEdit = useCallback((task: OpportunityTask) => {
    setEditingTask(task)
    setEditDialogOpen(true)
  }, [])

  const handleDelete = useCallback((task: OpportunityTask) => {
    setDeletingTask(task)
    setDeleteDialogOpen(true)
  }, [])

  return {
    editDialogOpen,
    setEditDialogOpen,
    editingTask,
    deleteDialogOpen,
    setDeleteDialogOpen,
    deletingTask,
    handleEdit,
    handleDelete,
  }
}
